import type { FaireProductEntity } from "../../entity_types/product";

export const p_fnpkp7exnn: FaireProductEntity = {
  token: "p_fnpkp7exnn",
  type: "product",
  name: "10 Day Parasite Cleanse, Capsules",
  brandToken: "b_zqh3u776ct",
  brandName: "Evergreen Apothecary",
  imageUrl:
    "https://cdn.faire.com/fastly/b4f8796b71e5288fa927f28ea131f5525814696f31e151958e83476c0c757939.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/348d4ed2164a138dfeba7716834fce0ddb7100239cd068a35b9eccd84480f977.jpeg",
    "https://cdn.faire.com/fastly/ab607941084a2116f2a8f9f5b56f03da4340faf006033923183a66549953793a.jpeg",
    "https://cdn.faire.com/fastly/a2d15208ed68f0b0fed20f29f5d016bc47be7a808cbabf7cccc384c368cb255a.jpeg",
    "https://cdn.faire.com/fastly/ba47d621b4656be0ab82efe28d2aa89866bba9c4210a896fbee965d80074201b.jpeg",
    "https://cdn.faire.com/fastly/2b08c46b5a30ff6dfae55a11070c63d6cbb94a8f1427a3d77a0367aec626e7f7.jpeg",
    "https://cdn.faire.com/fastly/0216cee100af3ca6131db5dc7aeb9adda96aad15096a67e52933f020d0326321.jpeg",
    "https://cdn.faire.com/fastly/c7d287a7de9978485a959566a28fa65d19433aac9bad05aca7d98e739f309ec9.jpeg",
  ],
  priceDollars: 25,
  description:
    "We recommend to pair this with our open pathways cleanse. Open pathways should be used first and then the parasite cleanse. \nOur 10 day parasite cleanse is made in small batches in our apothecary store front. It is simply made with herbs and no fillers. We are passionate about providing simple products that are non toxic. \nOur parasite cleanse is ideal if you suffer from:\n* Repeated diarrhea or constipation\n* Chronic, unexplained nausea\n* Fatigue and weakness\n* Low iron\n* Swelling around the eyes\n* Multiple food allergies\n* Intestinal cramping and/or bloating\n* Dizziness (not due to low blood sugar)\n* Foul-smelling gas\n* Heart Flutters/Palpitations\n* Loss of appetite\n* Unexplained itching around the anus, vulva, or feet, especially at night\n* Hair loss\n* Difficulty sleeping\n* Difficulty maintaining a healthy weight (weight gain or loss)\n* Teeth clenching or grinding\n* Strong sugar or carb cravings\n* Headaches\nThis contains a 10 day supply of capsules. \n\nOut of stock? Feel free to message us!\nLooking for white label? Send us a message and we are happy to work with you.",
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:44.645Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
